import React from "react";

export const CustomChairmanMail = "admin@test.com";
